export enum SocialNetworkParticipantsType {
  community = 'community',
  followers = 'followers',
  following = 'following',
}
